// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BenchmarkHeatmap_card__cXgsW {
  padding: 24px 24px 18px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.BenchmarkHeatmap_title__C3OEb {
  margin: 0 0 10px;
  font-family: "Lora", "Georgia", serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.BenchmarkHeatmap_subtitle__QqCZB {
  margin: 0 0 18px;
  font-size: 12px;
  color: var(--grey-text, #777);
  line-height: 1.45;
}

.BenchmarkHeatmap_chart__XRzZl {
  width: 100%;
  height: 360px;
}

.BenchmarkHeatmap_empty__LQLRE {
  padding: 20px 8px;
  font-size: 14px;
  color: var(--grey-text, #8a8a8a);
}

@media only screen and (max-width: 768px) {
  .BenchmarkHeatmap_card__cXgsW {
    padding: 18px 14px 14px;
  }
  .BenchmarkHeatmap_title__C3OEb {
    font-size: 18px;
  }
  .BenchmarkHeatmap_chart__XRzZl {
    height: 320px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BenchmarkHeatmap/BenchmarkHeatmap.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;;AAEA;EACE,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EAEA;IACE,eAAA;EAAF;EAGA;IACE,aAAA;EADF;AACF","sourcesContent":[".card {\n  padding: 24px 24px 18px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n}\n\n.title {\n  margin: 0 0 10px;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.subtitle {\n  margin: 0 0 18px;\n  font-size: 12px;\n  color: var(--grey-text, #777);\n  line-height: 1.45;\n}\n\n.chart {\n  width: 100%;\n  height: 360px;\n}\n\n.empty {\n  padding: 20px 8px;\n  font-size: 14px;\n  color: var(--grey-text, #8a8a8a);\n}\n\n@media only screen and (max-width: 768px) {\n  .card {\n    padding: 18px 14px 14px;\n  }\n\n  .title {\n    font-size: 18px;\n  }\n\n  .chart {\n    height: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BenchmarkHeatmap_card__cXgsW`,
	"title": `BenchmarkHeatmap_title__C3OEb`,
	"subtitle": `BenchmarkHeatmap_subtitle__QqCZB`,
	"chart": `BenchmarkHeatmap_chart__XRzZl`,
	"empty": `BenchmarkHeatmap_empty__LQLRE`
};
export default ___CSS_LOADER_EXPORT___;
